import { baseCognitiveBehavioral, baseComprehensionLanguage, baseEntMouth, baseExtremities, baseHandGrips, baseHearingSchema, baseNeuroMentalStatus, baseNeurologicalFindings, basePupils, baseVisionSchema, } from '../validations/shared/neurological';
import { basePainAssessmentSchema } from '../validations/shared/pain-assessment';
import { basePsychosocialSchema } from '../validations/shared/psychosocial';
const mentalShape = baseNeuroMentalStatus.shape;
const cognitiveShape = baseCognitiveBehavioral.shape;
const findingsShape = baseNeurologicalFindings.shape;
const gripsShape = baseHandGrips.shape;
const extremitiesShape = baseExtremities.shape;
const comprehensionShape = baseComprehensionLanguage.shape;
const pupilsShape = basePupils.shape;
const visionShape = baseVisionSchema.shape;
const hearingShape = baseHearingSchema.shape;
const entShape = baseEntMouth.shape;
const psychosocialShape = basePsychosocialSchema.shape;
const painShape = basePainAssessmentSchema.shape;
export const mentalFields = [
    { key: 'orientedToPerson', field: mentalShape.orientedToPerson },
    { key: 'orientedToPlace', field: mentalShape.orientedToPlace },
    { key: 'orientedToPurpose', field: mentalShape.orientedToPurpose },
    { key: 'orientedToTime', field: mentalShape.orientedToTime },
];
export const aphasiaFields = [
    { key: 'aphasiaDetails', field: cognitiveShape.aphasiaDetails, variant: 'tags' },
];
export const findingsFields = [
    { key: 'details', field: findingsShape.details, variant: 'tags' },
];
export const gripsFields = [
    { key: 'dominantHand', field: gripsShape.dominantHand },
    { key: 'equality', field: gripsShape.equality },
    { key: 'leftStrength', field: gripsShape.leftStrength },
    { key: 'rightStrength', field: gripsShape.rightStrength },
];
export const extremitiesFields = [
    { key: 'lue', field: extremitiesShape.lue },
    { key: 'rue', field: extremitiesShape.rue },
    { key: 'lle', field: extremitiesShape.lle },
    { key: 'rle', field: extremitiesShape.rle },
];
export const neurosensoryComprehensionFields = [
    { key: 'details', field: comprehensionShape.details, variant: 'tags' },
];
export const pupilsFields = [
    { key: 'equality', field: pupilsShape.equality },
    { key: 'shape', field: pupilsShape.shape },
    { key: 'size', field: pupilsShape.size },
    { key: 'leftReactivity', field: pupilsShape.leftReactivity },
    { key: 'rightReactivity', field: pupilsShape.rightReactivity },
];
export const visionFields = [
    { key: 'correctiveLenses', field: visionShape.correctiveLenses },
    { key: 'visionSeverity', field: visionShape.visionSeverity },
    { key: 'leftEye', field: visionShape.leftEye },
    { key: 'rightEye', field: visionShape.rightEye },
    { key: 'visualFieldDefect', field: visionShape.visualFieldDefect },
    { key: 'impactOnCare', field: visionShape.impactOnCare, variant: 'tags' },
];
export const hearingFields = [
    { key: 'hearingAidStatus', field: hearingShape.hearingAidStatus },
    { key: 'hearingAbility', field: hearingShape.hearingAbility },
    { key: 'leftEar', field: hearingShape.leftEar },
    { key: 'rightEar', field: hearingShape.rightEar },
    { key: 'comprehension', field: hearingShape.comprehension },
    { key: 'interpreterNeeded', field: hearingShape.interpreterNeeded },
    { key: 'impactOnCare', field: hearingShape.impactOnCare, variant: 'tags' },
];
export const entFields = [
    { key: 'details', field: entShape.details, variant: 'tags' },
];
export const psychosocialFields = [
    { key: 'status', field: psychosocialShape.status, variant: 'tags' },
];
export const painHasPainFields = [{ key: 'hasPain', field: painShape.hasPain }];
export function buildPainYesFields(showRelievedByOther) {
    return [
        { key: 'primarySite', field: painShape.primarySite },
        { key: 'receivedBy', field: painShape.receivedBy },
        { key: 'interferesWithActivity', field: painShape.interferesWithActivity },
        { key: 'currentPainIntensity', field: painShape.currentPainIntensity },
        { key: 'pastPainBest', field: painShape.pastPainBest },
        { key: 'pastPainWorst', field: painShape.pastPainWorst },
        { key: 'description', field: painShape.description, variant: 'tags' },
        { key: 'nonverbalPainCues', field: painShape.nonverbalPainCues, variant: 'tags' },
        { key: 'relievedBy', field: painShape.relievedBy, variant: 'tags' },
        ...(showRelievedByOther ? [{ key: 'relievedByOther', field: painShape.relievedByOther }] : []),
        { key: 'managementEffectiveness', field: painShape.managementEffectiveness },
        { key: 'aberrantBehavior', field: painShape.aberrantBehavior, variant: 'tags' },
        { key: 'painFrequency', field: painShape.painFrequency },
        { key: 'comments', field: painShape.comments },
    ];
}
export const painUnableFields = [
    { key: 'nonverbalSymptoms', field: painShape.nonverbalSymptoms, variant: 'tags' },
    { key: 'adlImpact', field: painShape.adlImpact },
    { key: 'reliefMeasures', field: painShape.reliefMeasures },
    { key: 'comments', field: painShape.comments },
];
